export default "__VITE_ASSET__DJ82lnBx__"